/**
 * 料金の説明に添える小さな 1 行。前払い残高（PrepaidPage）の下の「料金のしくみ」の段に出す
 *（2026-10-18 design/rauno-dashboard から。以前は前払い残高でも一番上のリードの下 = 残高より上だった）。
 * 利用料（UsagePage）のリードの下にも出していたが、同じ説明が 2 か所になるので、利用料からは「料金のしくみ」へのリンクにした
 *（2026-10-18 design/rauno-dashboard2・rauno-audit.md 使用額の行）。
 *   - 「Prices are at cost, including the tax our providers add.」（2026-10-07 追記 7・管理の判断）: いつも出す決まった 1 文。
 *     WHY 「10% consumption tax」と書かないか: 利用者に税を課しているように読める・国も匂う。税は請求書に税が載っている事業者の項目だけ
 *     （今は Cloudflare）に掛かる = 率は項目ごとに違う → 率（API の consumptionTaxPercent）に文を依存させない（以前は率が 0・無いと隠していた）
 *   - 「Usage is taken from your balance as it happens. …」（2026-10-07 founder の決定・money/cf-recon 追記 2/3）: 月末は戻すだけで、後から追加で引くことはない
 * WHY 1 か所の部品にするか: 2 つの画面で言い方がずれないように（サイトの料金ページ・CLI・MCP とも同じ文）
 */
import { useT } from '../../i18n';

export function PriceNotes() {
  const { t } = useT();
  return (
    <p className="page-lead muted small">
      {t('money.pricesFromProviders')}
      {/* 文と文の間: 英語は空白・日本語は無し（confirmPlain.sentenceGap と同じ決まり） */}
      {t('confirmPlain.sentenceGap')}
      {t('money.refundOnly')}
    </p>
  );
}
